import React from 'react'
import { cn } from '../lib/utils'

interface TypographyProps {
  children: React.ReactNode
  className?: string
}

export function H1({ children, className }: TypographyProps) {
  return (
    <h1 className={cn('text-h1 text-text-primary', className)}>
      {children}
    </h1>
  )
}

export function H2({ children, className }: TypographyProps) {
  return (
    <h2 className={cn('text-h2 text-text-primary', className)}>
      {children}
    </h2>
  )
}

export function H3({ children, className }: TypographyProps) {
  return (
    <h3 className={cn('text-h3 text-text-primary', className)}>
      {children}
    </h3>
  )
}

export function H4({ children, className }: TypographyProps) {
  return (
    <h4 className={cn('text-h4 text-text-primary', className)}>
      {children}
    </h4>
  )
}

export function H5({ children, className }: TypographyProps) {
  return (
    <h5 className={cn('text-h5 text-text-primary', className)}>
      {children}
    </h5>
  )
}

export function H6({ children, className }: TypographyProps) {
  return (
    <h6 className={cn('text-h6 text-text-primary', className)}>
      {children}
    </h6>
  )
}

export function Body({ children, className }: TypographyProps) {
  return (
    <p className={cn('text-body text-text-primary', className)}>
      {children}
    </p>
  )
}

export function Caption({ children, className }: TypographyProps) {
  return (
    <span className={cn('text-caption text-text-secondary', className)}>
      {children}
    </span>
  )
}